import { useState } from 'react';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Login({ onLogin }) {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    email: '',
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const endpoint = isLogin ? `${API}/auth/login` : `${API}/auth/register`;
      const payload = isLogin
        ? { email: formData.email, password: formData.password }
        : formData;

      const response = await axios.post(endpoint, payload);
      
      toast.success(isLogin ? 'Başarıyla giriş yapıldı!' : 'Hesap oluşturuldu!');
      onLogin(response.data.access_token, response.data.user);
    } catch (error) {
      const message = error.response?.data?.detail || 'Bir hata oluştu';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-xl p-8 animate-slide-up">
          <div className="text-center mb-8">
            <div className="text-6xl mb-4">😊</div>
            <h1 className="text-3xl font-bold text-gray-900 mb-2">MoodPulse</h1>
            <p className="text-gray-600">Ruh halinizi takip edin, kendinizi daha iyi anlayın</p>
          </div>

          <div className="flex gap-2 mb-6">
            <Button
              data-testid="toggle-login-btn"
              type="button"
              onClick={() => setIsLogin(true)}
              variant={isLogin ? 'default' : 'outline'}
              className="flex-1"
            >
              Giriş Yap
            </Button>
            <Button
              data-testid="toggle-register-btn"
              type="button"
              onClick={() => setIsLogin(false)}
              variant={!isLogin ? 'default' : 'outline'}
              className="flex-1"
            >
              Kayıt Ol
            </Button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="email">E-posta</Label>
              <Input
                id="email"
                data-testid="email-input"
                type="email"
                placeholder="ornek@email.com"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
              />
            </div>

            {!isLogin && (
              <div>
                <Label htmlFor="username">Kullanıcı Adı</Label>
                <Input
                  id="username"
                  data-testid="username-input"
                  type="text"
                  placeholder="kullaniciadi"
                  value={formData.username}
                  onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                  required
                />
              </div>
            )}

            <div>
              <Label htmlFor="password">Şifre</Label>
              <Input
                id="password"
                data-testid="password-input"
                type="password"
                placeholder="••••••••"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                required
              />
            </div>

            <Button
              data-testid="submit-btn"
              type="submit"
              className="w-full"
              disabled={loading}
            >
              {loading ? 'Lütfen bekleyin...' : isLogin ? 'Giriş Yap' : 'Kayıt Ol'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}